import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFiscalAdapter } from '../lib/fiscal/useFiscalAdapter';
import '../locales/parity';

export default function SettingsLayout({ children }) {
    const location = useLocation();
    const { t } = useTranslation();
    const { countryCode } = useFiscalAdapter();

    const tabs = [
        { name: 'business', path: '/settings/business' },
        { name: 'account', path: '/settings/account' },
        { name: 'team', path: '/settings/team' },
        { name: 'tariffs', path: '/settings/tariffs' },
        // Spain: Redsys TPV. Pakistan: JazzCash / Easypaisa / wallets portal.
        { name: 'payments', path: '/settings/payments', countries: ['ES', 'PK'] },
        { name: 'customization', path: '/settings/customization' },
        { name: 'plans', path: '/subscription' },
        { name: 'gestor', path: '/settings/gestor' },
        { name: 'api', path: '/settings/api', badge: 'NUEVO' },
        { name: 'integrations', path: '#', badge: 'BETA' }
    ].filter((tab) => !tab.countries || tab.countries.includes(countryCode));

    return (
        <div className="min-h-[calc(100vh-64px)] bg-[#f8fafc]">
            {/* Sub-navigation bar */}
            <div className="bg-[#f8fafc] border-b border-[#e1e5e8]">
                <div className="max-w-6xl mx-auto px-6">
                    <nav className="flex space-x-6 overflow-x-auto">
                        {tabs.map((tab) => {
                            const isActive = location.pathname === tab.path || (tab.path === '/subscription' && location.pathname === '/subscription');
                            return (
                                <Link
                                    key={tab.name}
                                    to={tab.path}
                                    className={`
                                        py-4 px-1 text-sm font-semibold flex items-center border-b-2 transition-colors whitespace-nowrap
                                        ${isActive 
                                            ? 'border-[#1a4f8b] text-[#1a4f8b]' 
                                            : 'border-transparent text-[#6d7d8b] hover:text-[#1a4f8b] hover:border-gray-300'}
                                    `}
                                >
                                    {t('settingsNav.' + tab.name)}
                                    {tab.badge && (
                                        <span className="ml-1.5 bg-[#1a4f8b] text-white text-[10px] px-1.5 py-0.5 rounded font-bold uppercase tracking-wide">
                                            {tab.badge}
                                        </span>
                                    )}
                                </Link>
                            );
                        })}
                    </nav>
                </div>
            </div>

            {/* Content area */}
            <div className="max-w-6xl mx-auto px-6 py-8">
                {children}
            </div>
        </div>
    );
}
